// extracted by mini-css-extract-plugin
export default {"weight_container":"style_weight_container__6wV4u","value_div":"style_value_div__USqwJ","metric__sub_title":"style_metric__sub_title__S5+4L"};